// extracted by mini-css-extract-plugin
module.exports = {"sideDrawer":"SideDrawer_sideDrawer__1R49D","icon":"SideDrawer_icon__3u5jG"};